export default __webpack_public_path__ + "static/media/PrescriptionsIcon.59786966.svg";